import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TableContainer,Table,TableHead,TableRow,TableBody, TableCell, Paper  } from '@material-ui/core'
import { EmptyCollection,  } from '../../../../shared_elements';
export default function ApprovalTimelineModal({ approvalData, toggleModalFn }) {
  const approvalStageObj ={ 1:"FINANCE CONTROL",2 :"ACCOUNTING CONTROL",3:"FINAL CONTROL"}
    const localTime = (dateTime)=>{return(new Date(dateTime).toLocaleString(undefined, {year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true}))} 
    const updatedApprovalData =approvalData?.length>0 && approvalData?.filter(item => item.status !== 'pending');
    return (
        <div>
            <Dialog  open='true' maxWidth="lg" >
                <DialogTitle>Approval History</DialogTitle>
                <DialogContent dividers={true}  >
                    {updatedApprovalData?.length > 0 ?  <TableContainer component={Paper}  className="scrollable-table scrollable-table-container">
                        <Table className="mui-table-format" stickyHeader>
                                <TableHead>
                                  <TableRow>
                                    <TableCell  >Approval Stage</TableCell>
                                    <TableCell  >Approved / Rejected By</TableCell>
                                    <TableCell  >Date & Time</TableCell>
                                    <TableCell  >Reason</TableCell>
                                    <TableCell  >Status</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody >
                                {
                                     updatedApprovalData?.map((item)=>{
                                        return(
                                          <TableRow style={{textAlign:'center'}}>
                                           <TableCell >{item?.stage ? approvalStageObj[item?.stage] : '--'}</TableCell>
                                           <TableCell >{item?.created_by?.name ? item?.created_by?.name : "--"}</TableCell>
                                           <TableCell >{item?.created_at ? localTime(item?.created_at) : "--"}</TableCell>
                                           <TableCell >{item.remark ? item?.remark : '--'}</TableCell>
                                           <TableCell >{item?.status ? item?.status === "reject" ? "Rejected": item?.status[0].toUpperCase() + item?.status.slice(1).toLowerCase(): '--'}</TableCell>
                                          </TableRow>
                                        )
                                       })
                                    }
                                </TableBody>
                                </Table>                     
                                </TableContainer>
                   :  <EmptyCollection
                        title="No Records Found"
                    />}
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginLeft: "15px" }} color="primary" size='small' variant='outlined' onClick={toggleModalFn}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
